import { Routes } from '@angular/router';
import { AuthComponent } from '@app/auth/auth.component';
import { DeletedComponent } from '@app/auth/pages/deleted/deleted.component';
import { LoginCompanySelectComponent } from '@app/auth/pages/login-company-select/login-company-select.component';
import { LoginEmailInputComponent } from '@app/auth/pages/login-email-input/login-email-input.component';
import { LoginStatusComponent } from '@app/auth/pages/login-status/login-status.component';
import { LoginVerificationCodeComponent } from '@app/auth/pages/login-verification-code/login-verification-code.component';
import { TermsAndConditionsAgreementComponent } from '@app/auth/pages/terms-and-conditions-agreement/terms-and-conditions-agreement.component';
import { CookiePolicyComponent } from '@app/landing/pages/cookie-policy/cookie-policy.component';
import { paths } from '@platform/paths';
import { PreloadCheckpointsEnum } from '@shared/enums/preload-checkpoints.enum';
import { AuthGuard } from '@shared/guards/auth.guard';
import { AuthenticatedGuard } from '@shared/guards/authenticated.guard';
import { maintenanceModeGuard, maintenancePageGuard } from '@shared/guards/maintenance.guard';

export const routes: Routes = [
  {
    title: 'Maintenance',
    path: paths.MAINTENANCE,
    canActivate: [maintenancePageGuard],
    loadComponent: async () => (await import('@shared/components/maintenance/maintenance.component')).MaintenanceComponent,
  },
  {
    path: paths.PLATFORM,
    canMatch: [maintenanceModeGuard],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./platform/platform.routes').then((r) => r.platformRoutes),
    data: { preload: true, preloadCheckpoint: PreloadCheckpointsEnum.Platform },
  },
  {
    title: 'Delete Account',
    path: `${paths.AUTH}/${paths.auth.DELETE_ACCOUNT}`,
    canMatch: [maintenanceModeGuard],
    component: DeletedComponent,
  },
  {
    path: paths.AUTH,
    canMatch: [maintenanceModeGuard],
    component: AuthComponent,
    canActivate: [AuthenticatedGuard],
    children: [
      {
        path: paths.auth.AUTH_TOKEN,
        pathMatch: 'full',
        redirectTo: paths.auth.LOGIN_STATUS,
      },
      {
        title: 'Auth code',
        path: paths.auth.AUTH_CODE,
        component: AuthComponent,
      },
      {
        title: 'Delete Account',
        path: paths.auth.DELETE_ACCOUNT,
        component: DeletedComponent,
      },
      {
        title: 'Login',
        path: paths.auth.LOGIN,
        component: LoginEmailInputComponent,
      },
      {
        title: 'Account Select',
        path: paths.auth.ACCOUNT_SELECT,
        component: LoginCompanySelectComponent,
      },
      {
        title: 'Terms And Conditions',
        path: paths.auth.TERMS_AND_CONDITIONS,
        component: TermsAndConditionsAgreementComponent,
      },
      {
        title: 'Login Verification',
        path: paths.auth.LOGIN_VERIFICATION,
        component: LoginVerificationCodeComponent,
      },
      {
        title: 'Signing In',
        path: paths.auth.LOGIN_STATUS,
        component: LoginStatusComponent,
      },
      {
        path: '**',
        redirectTo: paths.auth.LOGIN,
      },
    ],
  },
  {
    title: 'Cookie Policy',
    path: paths.COOKIE_POLICY,
    canMatch: [maintenanceModeGuard],
    component: CookiePolicyComponent,
  },
  {
    title: 'Unsubscribe',
    path: paths.UNSUBSCRIBE,
    canMatch: [maintenanceModeGuard],
    loadComponent: async () => (await import('@app/landing/pages/unsubscribe/unsubscribe.component')).UnsubscribeComponent,
  },
  {
    title: 'Sign Up',
    path: paths.SIGN_UP,
    canMatch: [maintenanceModeGuard],
    loadComponent: async () => (await import('./sign-up/sign-up.component')).SignUpComponent,
    loadChildren: () => import('./sign-up/sign-up.routes').then((r) => r.signUpRoutes),
  },
  // Old ULC redirect
  { path: 'register', redirectTo: paths.SIGN_UP },
  {
    path: '**',
    redirectTo: paths.PLATFORM,
  },
];
